import { forwardRef } from "react";
import { cx } from "../../utils";

const variantClasses = {
  primary:
    "bg-ink-900 text-white hover:bg-ink-800 disabled:bg-ink-300 shadow-sm border border-ink-900/10",
  gradient:
    "text-white bg-brand-gradient shadow-brand-glow hover:shadow-brand-glow hover:saturate-150 disabled:opacity-60",
  secondary:
    "bg-white text-ink-700 border border-ink-200 hover:bg-ink-50 hover:border-ink-300 shadow-sm",
  ghost: "bg-transparent text-ink-600 hover:bg-ink-100 hover:text-ink-900",
  danger: "bg-rose-600 text-white hover:bg-rose-700 disabled:bg-rose-300 shadow-sm",
};

const sizeClasses = {
  sm: "h-8 px-3 text-xs gap-1.5 rounded-lg",
  md: "h-9 px-3.5 text-sm gap-2 rounded-lg",
  lg: "h-10 px-4 text-sm gap-2 rounded-lg",
  icon: "h-9 w-9 rounded-lg",
};

const Button = forwardRef(
  (
    {
      as: Tag = "button",
      variant = "primary",
      size = "md",
      icon,
      iconRight,
      loading,
      disabled,
      children,
      className = "",
      ...rest
    },
    ref,
  ) => (
    <Tag
      ref={ref}
      disabled={Tag === "button" ? disabled || loading : undefined}
      className={cx(
        "inline-flex items-center justify-center font-medium transition-all duration-150 active:scale-[0.98]",
        "disabled:cursor-not-allowed disabled:active:scale-100",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/30 focus-visible:ring-offset-1",
        variantClasses[variant],
        sizeClasses[size],
        className,
      )}
      {...rest}
    >
      {loading ? (
        <svg className="animate-spin" width="14" height="14" viewBox="0 0 24 24" fill="none">
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeOpacity="0.3"
            strokeWidth="3"
          />
          <path
            d="M22 12a10 10 0 0 0-10-10"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      ) : (
        icon
      )}
      {children}
      {iconRight}
    </Tag>
  ),
);

Button.displayName = "Button";
export default Button;
